import React from "react";
import { Skeleton } from "@heroui/skeleton";

const StockValuationSkeleton = () => {
  return (
    <div className="relative flex flex-col mt-4 items-center justify-between p-5 mb-4 sm:mb-4 md:mb-4 bg-white shadow-md rounded-lg border">
      <div className="w-full flex justify-between items-center mb-4">
        <Skeleton className="h-8 w-1/2 mb-2" />{" "}
        {/* Placeholder for the title */}
        <Skeleton className="h-8 w-20 rounded-lg" />{" "}
        {/* Placeholder for the chip */}
      </div>
      <div className="w-full flex justify-between items-center mt-4">
        <Skeleton className="h-6 w-1/3" />{" "}
        {/* Placeholder for Fair Value Premium */}
        <Skeleton className="h-6 w-1/4" />{" "}
        {/* Placeholder for the percentage */}
      </div>
      <Skeleton className=" h-450 w-full mt-5" />{" "}
      {/* Placeholder for the chart */}
    </div>
  );
};

export default StockValuationSkeleton;
